import React from 'react';
import HeaderTwo from '../../components/header/HeaderTwo';
import Footer from '../../components/footer/Footer';
import Breadcrumb from './Breadcrumb';
import AboutInner from './AboutInner'
import LatestMatch from './LatestMatch'
import WhatNext from './what-next'
import OurDeployments from './out-deployments';
import GameCategories from './game-categories';
import WeUse from './we-use';
import GamesArea from './realsed-games';

export default function BusinessModelGamesGuru() {
  return (
	<>
	<HeaderTwo/>
	<main>
	<Breadcrumb/>
	<AboutInner/>	
	<LatestMatch/>
	<WeUse/>
	<WhatNext/>
	<GameCategories/>
	<OurDeployments/>
	<GamesArea/>
	</main>
	<Footer/>
	</>
  )
}


